import {
  DesignProject,
  OnboardingStep,
  UpdateDesignProjectOnboardingStepDto,
} from "@yardzen/api-dtos";
import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";
import { createServerApiClient } from "../server-base-client";

const baseUrl = "design-projects";

const getApiClient = async (authToken?: string) => {
  if (authToken) {
    return await createServerApiClient(authToken);
  }
  return apiClient;
};

export async function getDesignProject(
  designProjectId: string,
  authToken?: string,
): Promise<AxiosResponse<DesignProject>> {
  const api = await getApiClient(authToken);
  return api.get(`${baseUrl}/${designProjectId}`);
}

export async function listDesignProjects(
  authToken?: string,
): Promise<AxiosResponse<DesignProject[]>> {
  const api = await getApiClient(authToken);
  return api.get(baseUrl);
}

export async function createDesignProject(
  authToken?: string,
): Promise<AxiosResponse<DesignProject>> {
  const api = await getApiClient(authToken);
  return api.post(baseUrl);
}

export async function updateOnboardingStep(
  accountId: string,
  designProjectId: string,
  body: UpdateDesignProjectOnboardingStepDto,
): Promise<AxiosResponse<OnboardingStep>> {
  return apiClient.put(
    `/accounts/${accountId}/design-projects/${designProjectId}/onboarding/step`,
    body,
  );
}
